import React from "react";

type Props = {
  title: string | null;
};

const GeneralError = ({ title }: Props) => {
  return (
    <div className="text-center">
      <h1 className="text-xl font-bold">{title ?? "Something went wrong. Please try again later."}</h1>
    </div>
  );
};

export default GeneralError;
